<template>
  <b-alert v-if="shouldShowBanner" :show="true" variant="warning" class="mb-0 text-center">
    <div class="container" ref="maintenance-message">
      <div v-if="isRecurringMaintenance && !isOneTimeMaintenance">
        You are currently visiting mini-my. Tuesdays {{ recurringMaintenanceTimeRange }} (Warwick Time) is the my.wbs at risk period
        when we perform essential updates and maintenance. Whilst my.wbs is unavailable and to ensure a smooth
        experience, users are automatically redirected to mini-my during this time.
      </div>
      <div v-if="isOneTimeMaintenance">
        You are currently visiting mini-my. On {{ oneTimeMaintenanceDateFormatted }}, {{ oneTimeMaintenanceTimeRange }} (Warwick Time), my.wbs will be unavailable
        due to a planned systems infrastructure upgrade. Whilst my.wbs is unavailable and to ensure a smooth experience,
        users are automatically redirected to mini-my during this time.
      </div>
    </div>
  </b-alert>
</template>

<script>
import { timeService} from "@/services/time.service";

export default {
  name: 'MaintenanceAlert',

  inject: {
    timeService: {
      default: () => timeService
    }
  },

  data() {
    return {
      recurringMaintenanceStart: { hour: 7, minute: 0 },
      recurringMaintenanceEnd: { hour: 8, minute: 15 },
      oneTimeMaintenanceDate: { day: 30, month: 8, year: 2025 },
      oneTimeMaintenanceStart: { hour: 17, minute: 0 },
      oneTimeMaintenanceEnd: { hour: 0, minute: 0 }
    }
  },

  computed: {
    isRecurringMaintenance() {
      return this.isRecurringMaintenanceWindow();
    },

    isOneTimeMaintenance() {
      return this.isOneTimeMaintenanceWindow();
    },

    shouldShowBanner() {
      const isVisible = this.isRecurringMaintenance || this.isOneTimeMaintenance;
      this.$store.dispatch('appState/setMaintenanceMode', isVisible);
      return isVisible
    },

    recurringMaintenanceTimeRange() {
      const startTime = this.formatTime(this.recurringMaintenanceStart.hour, this.recurringMaintenanceStart.minute);
      const endTime = this.formatTime(this.recurringMaintenanceEnd.hour, this.recurringMaintenanceEnd.minute);
      return `${startTime} - ${endTime}`;
    },

    oneTimeMaintenanceDateFormatted() {
      const date = new Date(this.oneTimeMaintenanceDate.year, this.oneTimeMaintenanceDate.month - 1, this.oneTimeMaintenanceDate.day);
      const dayName = date.toLocaleDateString('en-GB', { weekday: 'long' });
      const dayNumber = this.oneTimeMaintenanceDate.day;
      const monthName = date.toLocaleDateString('en-GB', { month: 'long' });
      const dayWithSuffix = this.addOrdinalSuffix(dayNumber);
      return `${dayName} ${dayWithSuffix} ${monthName}`;
    },

    oneTimeMaintenanceTimeRange() {
      const startTime = this.formatTime(this.oneTimeMaintenanceStart.hour, this.oneTimeMaintenanceStart.minute);
      const endTime = this.formatTime(this.oneTimeMaintenanceEnd.hour, this.oneTimeMaintenanceEnd.minute);
      return `${startTime} – ${endTime}`;
    }
  },

  methods: {
    formatTime(hour, minute) {
      const formattedHour = hour.toString().padStart(2, '0');
      const formattedMinute = minute.toString().padStart(2, '0');
      return `${formattedHour}:${formattedMinute}`;
    },

    addOrdinalSuffix(day) {
      if (day >= 11 && day <= 13) {
        return `${day}th`;
      }
      switch (day % 10) {
        case 1: return `${day}st`;
        case 2: return `${day}nd`;
        case 3: return `${day}rd`;
        default: return `${day}th`;
      }
    },

    isRecurringMaintenanceWindow() {
      const currentDateTime = this.timeService.getCurrentDate();

      if (currentDateTime.getDay() !== 2) return false;

      const startTime = new Date(currentDateTime);
      startTime.setHours(this.recurringMaintenanceStart.hour, this.recurringMaintenanceStart.minute, 0, 0);

      const endTime = new Date(currentDateTime);
      endTime.setHours(this.recurringMaintenanceEnd.hour, this.recurringMaintenanceEnd.minute, 0, 0);

      return currentDateTime >= startTime && currentDateTime < endTime;
    },

    isOneTimeMaintenanceWindow() {
      const currentDateTime = this.timeService.getCurrentDate();

      const startTime = new Date(this.oneTimeMaintenanceDate.year, this.oneTimeMaintenanceDate.month - 1, this.oneTimeMaintenanceDate.day);
      startTime.setHours(this.oneTimeMaintenanceStart.hour, this.oneTimeMaintenanceStart.minute, 0, 0);

      const endTime = new Date(this.oneTimeMaintenanceDate.year, this.oneTimeMaintenanceDate.month - 1, this.oneTimeMaintenanceDate.day + 1);
      endTime.setHours(this.oneTimeMaintenanceEnd.hour, this.oneTimeMaintenanceEnd.minute, 0, 0);

      return currentDateTime >= startTime && currentDateTime < endTime;
    }
  },

  mounted() {
    this.timer = setInterval(() => {
      this.$forceUpdate();
    }, 60000);
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
</script>